import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { toQueryParams } from 'helpers/api';
import { stringDate } from 'helpers/date';
import cookie from 'react-cookies';

export const servicesApi = createApi({
  reducerPath: 'servicesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URl}/services`,
    prepareHeaders: headers => {
      headers.set('Authorization', `Bearer ${cookie.load('token')}`);
      return headers;
    },
  }),
  endpoints: builder => ({
    getACICExportFile: builder.query({
      queryFn: async (params, api, extraOptions, baseQuery) => {
        const { data: file } = await baseQuery({
          url: `/acic/export_file`,
          responseHandler: async response => {
            const blob = await response.blob();
            return blob;
          },
          cache: 'no-cache',
        });
        saveAs(file, 'acic_export_file.xml');
        return { data: null };
      },
    }),
  }),
});

export const { useLazyGetACICExportFileQuery } = servicesApi;
